import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'


export const getSocietyProfileReq = (action) => {
    const societyId = action?.data?.id || ''
    const url = apiEndpoints.GET_SOCIETY_PROFILE_API.replace(':id', societyId)
    return axiosInstance.get(url);
}

export const updateSocietyProfileReq = (action) => {
    const societyId = action?.data?.id || ''
    const url = apiEndpoints.UPDATE_SOCIETY_PROFILE_API.replace(':id', societyId)
    return axiosInstance.patch(url, action?.data?.payload);
}
